module.exports = __webpack_public_path__ + "static/gauntlet-logo-eb941d59aa81006b00fd1f867068e405.png";